'use strict';

var React = require('react');

var SvgTaxIcon = function SvgTaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.692 9.308a.625.625 0 0 1 0 .884l-4.5 4.5a.625.625 0 1 1-.884-.884l4.5-4.5a.625.625 0 0 1 .884 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.025 2.5c-.562 0-1.024.467-.914 1.018.19.959.613 1.744 1.172 2.267a5.307 5.307 0 0 0-3.285 3.25l-1.108 3.13c-.922 2.603 1.008 5.335 3.77 5.335h4.68c2.761 0 4.692-2.732 3.77-5.335l-1.108-3.13a5.306 5.306 0 0 0-3.285-3.25c.559-.523.981-1.308 1.172-2.267.11-.551-.352-1.018-.914-1.018h-3.95Zm1.975 2.5c-.295 0-.826-.231-1.176-1h2.352c-.35.769-.88 1-1.176 1Zm3.588 4.536 1.108 3.13a2.5 2.5 0 0 1-2.356 3.334h-4.68a2.5 2.5 0 0 1-2.356-3.335l1.108-3.13a3.806 3.806 0 0 1 7.176 0Z"
  }));
};
SvgTaxIcon.displayName = "TaxIcon";

exports.SvgTaxIcon = SvgTaxIcon;
